import script from "./InvoiceSection5.vue?vue&type=script&setup=true&lang=js"
export * from "./InvoiceSection5.vue?vue&type=script&setup=true&lang=js"

import "./InvoiceSection5.vue?vue&type=style&index=0&id=33f5d5d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33f5d5d4"]])

export default __exports__